export default __webpack_public_path__ + "static/media/altius_logo.02d80132.png";